import { isDevEnv } from '@libs/utils';
import { Route } from 'react-router';

// TODO: 一部取込機能をlocal or dev or test環境でのみ表示させる。リリースに含めるときに戻す。
export const devFaRoutes = isDevEnv()
  ? [
      <Route
        key="la-article-info-change-import"
        path="la-article-info-change-import"
        lazy={async () => import('./pages/LaArticleInfoChangeImport')}
      />,
      <Route
        key="la-article-principal-repayment-schedule"
        path="la-article-principal-repayment-schedule"
        lazy={async () => import('./pages/LaArticlePrincipalRepaymentSchedule')}
      />,
      <Route
        key="fixed-asset-depreciation-item-change"
        path="fixed-asset-depreciation-item-change/*"
        lazy={async () => import('./pages/FixedAssetDepreciationItemChange')}
      />,
      <Route
        key="fa-depreciation-item-change-import"
        path="fa-depreciation-item-change-import"
        lazy={async () => import('./pages/FaDepreciationItemChangeImport')}
      />,
    ]
  : [];
